export enum FormEvent {
  ValueChange = 'form-value-change',
  ToggleableChange = 'form-toggleable-change',
  OnDisableInput = 'form-input-on-disable',
  FormInvalid = 'form-value-invalid',
  FormValid = 'form-value-valid',
}
